/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Help_Permissionstable2Inputs */

const en_usermanagement_help_permissionstable2 = /** @type {(inputs: Usermanagement_Help_Permissionstable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`permissions table`)
};

/**
* | output |
* | --- |
* | "permissions table" |
*
* @param {Usermanagement_Help_Permissionstable2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_help_permissionstable2 = /** @type {((inputs?: Usermanagement_Help_Permissionstable2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Help_Permissionstable2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_help_permissionstable2(inputs)
});
export { usermanagement_help_permissionstable2 as "userManagement_help_permissionsTable" }